import { render, staticRenderFns } from "./Copywriting.vue?vue&type=template&id=6d82043d&scoped=true&"
import script from "./Copywriting.vue?vue&type=script&lang=ts&"
export * from "./Copywriting.vue?vue&type=script&lang=ts&"
import style0 from "./Copywriting.vue?vue&type=style&index=0&id=6d82043d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82043d",
  null
  
)

export default component.exports